<template>
  <article class="consumable-card">
    <div class="consumable-title">
      <span class="consumable-icon"></span>
      <span>{{ item.name }}</span>
    </div>
    <div class="consumable-summary">
      <span class="flow-summary">
        {{ item.flowProgress.remaining.toFixed(0) }}/{{ item.settingFlow }}m³
      </span>
      <span class="day-summary">
        {{ item.dayProgress.remaining.toFixed(0) }}/{{ item.settingDays }}天
      </span>
    </div>
    <div class="consumable-progress-row">
      <span
        v-for="index in item.flowProgress.greenSegments"
        :key="`flow-green-${index}`"
        class="progress-block progress-block--green"
      ></span>
      <span
        v-for="index in item.flowProgress.graySegments"
        :key="`flow-gray-${index}`"
        class="progress-block progress-block--gray"
      ></span>
      <span class="progress-percent">{{ item.flowProgress.remainingPercent }}%</span>
    </div>
    <div class="consumable-progress-row">
      <span
        v-for="index in item.dayProgress.greenSegments"
        :key="`day-blue-${index}`"
        class="progress-block progress-block--blue"
      ></span>
      <span
        v-for="index in item.dayProgress.graySegments"
        :key="`day-gray-${index}`"
        class="progress-block progress-block--gray"
      ></span>
      <span class="progress-percent">{{ item.dayProgress.remainingPercent }}%</span>
    </div>
  </article>
</template>

<script>
import { parseConsumable } from "../../utils/protocol/consumables";

export default {
  name: "ConsumableCard",
  props: {
    protocol: {
      type: Object,
      default: () => ({})
    },
    consumableKey: {
      type: String,
      required: true
    }
  },
  computed: {
    item() {
      return (
        parseConsumable(this.protocol, this.consumableKey) || {
          name: "--",
          settingFlow: 0,
          settingDays: 0,
          flowProgress: {
            consumed: 0,
            remaining: 0,
            remainingPercent: 0,
            greenSegments: 0,
            graySegments: 23
          },
          dayProgress: {
            consumed: 0,
            remaining: 0,
            remainingPercent: 0,
            greenSegments: 0,
            graySegments: 23
          }
        }
      );
    }
  }
};
</script>

<style scoped>
.consumable-card {
  width: 250px;
  height: 120px;
  color: #fff;
}

.consumable-title {
  display: flex;
  margin: 14px 0 0 12px;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
}

.consumable-icon {
  width: 20px;
  height: 20px;
  margin-right: 4px;
  background: url("/images/dashboard/haocaiicon.png") no-repeat center / 100% 100%;
}

.consumable-summary {
  display: flex;
  height: 18px;
  margin: 5px 0 0 12px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

.flow-summary { margin-right: 8px; color: #33ff6a; }
.day-summary { color: #0095ff; }

.consumable-progress-row {
  display: flex;
  height: 16px;
  margin: 8px 0 0 12px;
  align-items: center;
}

.progress-block {
  width: 6px;
  height: 16px;
  margin-right: 2px;
  border-radius: 1px;
}

.progress-block--green { background: linear-gradient(270deg, #00ffa6 0%, #049344 100%); }
.progress-block--blue { background: linear-gradient(270deg, #0095ff 0%, #004f99 100%); }
.progress-block--gray { background: rgba(116, 122, 129, 0.25); }

.progress-percent {
  margin-left: 9px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-weight: 400;
}
</style>
